import React, { useRef } from 'react';
import styled from 'styled-components';
import profilePicture from 'assets/profilePicture.svg';

const FileOverlay = styled.input`
  background-color: rgba(0, 0, 0, 0.5);
  background-image: url(${profilePicture});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
`;

const Overlay: React.FC<{
  show: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ show, onChange }) => {
  const fileRef = useRef<HTMLInputElement>(null);

  if (!show) return null;

  const onClick = () => {
    fileRef?.current?.click();
  };

  return (
    <React.Fragment>
      <FileOverlay onClick={onClick} />
      <input
        ref={fileRef}
        style={{ display: 'none' }}
        type="file"
        onChange={onChange}
      />
    </React.Fragment>
  );
};

export default Overlay;
